<template>
  <table class="table" :id="dataTable.id">
    <thead>
      <tr>
        <th>Nº</th>
        <th>Título</th>
        <th>Descrição</th>
        <th class="text-center">Período de Execução</th>
        <th class="text-center">Status</th>
        <th class="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="project in projects" :key="project.id">
        <td>{{ project.id }}</td>
        <td>{{ project.title }}</td>
        <td :title="project.description">
          {{ project.description.substr(0, 100) }}...
        </td>
        <td class="text-center">{{ project.runtime }} (meses)</td>
        <td
          class="text-center"
          v-html="statusProjectTranslate(project.status)"
        />
        <td class="text-center">
          <router-link
            :to="`projects/${project.id}`"
            class="btn btn-outline-primary btn-icon rounded-pill"
            title="Detalhes"
          >
            <i class="ph-file-text" />
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { statusProjectTranslate } from '@/utils/strings'

export default {
  name: 'ListProjects',

  props: {
    projects: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      dataTable: {
        id: 'dataTableListProjects',
        order: [[0, 'desc']],
        columnDefs: [
          {
            targets: [5],
            orderable: false,
            width: 100,
          },
        ],
      },
      statusProjectTranslate,
    }
  },

  methods: {
    createDataTable() {
      window.$(`#${this.dataTable.id}`).DataTable({
        order: this.dataTable.order,
        columnDefs: this.dataTable.columnDefs,
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
